import { render, staticRenderFns } from "./import-batch-deletion.vue?vue&type=template&id=0a6cc926&scoped=true"
import script from "./import-batch-deletion.vue?vue&type=script&lang=ts"
export * from "./import-batch-deletion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6cc926",
  null
  
)

export default component.exports